import { util } from './utils'
const constants = {
  crossScreen: '',
  notFound: '',
  noPermission: '',
  versionLimit: '',
  invite: '',
  getPassword: '',
  noFunction: '',
  noMenuFunction: '',
  completeInfo: '',
  login: '',
  app: '',
  analysis: '', // 通用分析
  zgSee: '',
  user: '',
  userGroup: '',
  test: '',
  tool: '',
  crash: '',
  page: '',
  // 看板
  panel: '', // 看板
  dataPanel: '', // 数据看板
  dataview: '', // 数据概览
  // 场景分析
  scene: '',
  userGrowth: '',
  channel: '',
  pathAnalysis: '',
  retention: '',
  revenue: '',
  iteration: '', // 产品迭代

  manage: '', // 数据管理
  appUser: '',
  appUserList: '',
  appUserGroup: '',
  appUserPortrait: '',
  wholeAnalysis: '',
  eventAnalysis: '',
  funnelAnalysis: '',
  revenueAnalysis: '',
  retentionAnalysis: '',

  stickinessAnalysis: '',
  warningCreateIframe: '', // 创建预警（老模块）
  funnelCreateIfram: '', // 创建漏斗（老模块）
  productUpdate: '',
  diy: '', // 自定义指标
  diypage: '', // 自定义页面
  wechat: {
    index: '',
    wxWhole: '',
    wxFlow: '',
    wxMini: {
      index: '',
      activity: '',
      share: ''
    },
    wxMarketing: {
      index: '',
      reply: '',
      promote: ''
    }
  },
  advertisement: {
    index: '',
    sem: '',
    digital: '',
    realTime: '',
    history: '',
    landingPage: ''
  },
  version: {
    index: '',
    config: '',
    detail: '',
    whole: ''
  },
  dataAccess: {
    index: '',
    advertisement: '',
    guide: '',
    manage: '',
    debug: '',
    jsEventVisualizer: ''
  },
  warning: {
    index: '',
    list: '',
    create: '',
    editor: ''
  },
  registered: {
    index: '',
    one: '',
    two: '',
    three: '',
    four: '',
    five: '',
    six: '',
    finish: ''
  },
  setting: {
    index: '',
    update: '',
    app: {
      index: '',
      appInfo: '',
      member: '',
      virtualAppSource: '',
      source: '',
      medium: '',
      secretKey: '',
      dataFilter: ''
    },
    company: {
      index: '',
      createApp: '',
      info: '',
      appList: '',
      virtualApp: '',
      virtualAppConfig: '',
      user: '',
      userGroup: '',
      cost: '',
      weChatBinding: ''
    },
    personal: {
      index: '',
      info: '',
      reset: ''
    }
  },
  registeredNew: {
    index: '',
    info: '',
    success: ''
  },
  customScene: ''
}
util.initializeConstants(constants, 'router')
export default constants
